/** Achievements, streaks, and BEAM certification API client. */

import { authFetch } from "@/lib/api";

export async function fetchAchievements() {
  const res = await authFetch("/api/achievements");
  if (!res.ok) throw new Error("Could not load achievements");
  return res.json();
}

export async function fetchAchievementNotifications() {
  const res = await authFetch("/api/achievements/notifications");
  if (!res.ok) return { items: [] };
  return res.json();
}

export async function acknowledgeAchievementNotifications() {
  const res = await authFetch("/api/achievements/notifications/acknowledge", { method: "POST" });
  if (!res.ok) return { acknowledged: 0 };
  return res.json();
}

export async function fetchStreaks() {
  const res = await authFetch("/api/achievements/streaks");
  if (!res.ok) return null;
  return res.json();
}

export async function fetchBeamCertification() {
  const res = await authFetch("/api/achievements/beam-certification");
  if (res.status === 403) return null;
  if (!res.ok) throw new Error("Could not load BEAM certification");
  return res.json();
}
